import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { adminApi } from "../lib/api";
import { CONTACT } from "../constants/contact";

const rs = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
const tm = (v) => (v ? new Date(v).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" }) : "—");

export default function PayoutSlipPage() {
  const { token } = useParams();
  const [d, setD] = useState(undefined);
  useEffect(() => {
    adminApi.get(`/hk/slip/${token}`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [token]);
  if (d === undefined) return <p className="p-10 text-center text-slate-500">Loading…</p>;
  if (d === null) return <p data-testid="slip-invalid" className="p-10 text-center text-red-600">This slip link is invalid or expired.</p>;
  return (
    <div className="min-h-screen bg-slate-100 py-8 print:bg-white print:py-0">
      <div data-testid="payout-slip" className="mx-auto max-w-3xl bg-white p-8 text-slate-900 shadow print:shadow-none">
        <div className="flex items-start justify-between border-b-2 border-orange-500 pb-4">
          <div>
            <p className="font-heading text-2xl font-extrabold">Balangir Group</p>
            <p className="text-xs text-slate-500">{CONTACT.address}</p>
          </div>
          <div className="text-right">
            <p className="font-heading text-lg font-bold text-orange-600">PAYOUT SLIP</p>
            <p className="text-xs text-slate-500">{new Date(d.generated_at).toLocaleString("en-IN")}</p>
          </div>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
          <p>Employee: <b data-testid="slip-name">{d.full_name}</b></p>
          <p>Reference: <b className="font-mono">{d.reference}</b></p>
          <p>Role: {d.job_role}</p>
          <p>District: {d.district}</p>
        </div>
        <table className="mt-5 w-full text-xs">
          <thead><tr className="border-b border-slate-300 bg-slate-50 text-left">
            {["Date", "Booking", "In", "Out", "Hours", "Wage", "OT", "Travel", "5★", "Total", "Status"].map((h) => <th key={h} className="px-1.5 py-1.5">{h}</th>)}
          </tr></thead>
          <tbody>
            {d.shifts.map((s) => (
              <tr key={s.booking + s.check_in} data-testid="slip-row" className="border-b border-slate-200">
                <td className="px-1.5 py-1">{s.date}</td><td className="px-1.5 py-1">{s.booking}<br /><span className="text-slate-500">{s.service}</span></td>
                <td className="px-1.5 py-1">{tm(s.check_in)}</td><td className="px-1.5 py-1">{tm(s.check_out)}</td><td className="px-1.5 py-1">{s.hours}</td>
                <td className="px-1.5 py-1">{rs(s.wage)}</td><td className="px-1.5 py-1">{rs(s.overtime_pay)}</td><td className="px-1.5 py-1">{rs(s.travel_allowance)}</td>
                <td className="px-1.5 py-1">{rs(s.bonus)}</td><td className="px-1.5 py-1 font-semibold">{rs(s.total_payout)}</td>
                <td className={`px-1.5 py-1 font-semibold ${s.paid ? "text-emerald-700" : "text-amber-700"}`}>{s.paid ? "Paid" : "Due"}</td>
              </tr>
            ))}
            {d.shifts.length === 0 && <tr><td colSpan={11} className="py-4 text-center text-slate-500">No completed shifts.</td></tr>}
          </tbody>
        </table>
        <div className="mt-5 ml-auto w-64 space-y-1 text-sm">
          <p className="flex justify-between"><span>Total earned</span><b data-testid="slip-total">{rs(d.total)}</b></p>
          <p className="flex justify-between text-emerald-700"><span>Paid</span><b>{rs(d.paid)}</b></p>
          <p className="flex justify-between border-t border-slate-300 pt-1 text-amber-700"><span>Balance due</span><b data-testid="slip-due">{rs(d.unpaid)}</b></p>
        </div>
        <p className="mt-6 text-[11px] text-slate-500">Wage ₹700 per 8-hour shift · overtime ₹100/hour · travel ₹10/km (₹100–₹200) · ₹50 bonus for a 5★ rating. Computer-generated slip.</p>
        <button onClick={() => window.print()} data-testid="slip-print" className="mt-6 flex items-center gap-2 bg-orange-500 px-5 py-2 font-semibold text-white print:hidden"><Printer className="h-4 w-4" />Print / Save PDF</button>
      </div>
    </div>
  );
}
